import { render, staticRenderFns } from "./AtomButtonTheModalCloseIcon.vue?vue&type=template&id=7024ca0c"
import script from "./AtomButtonTheModalCloseIcon.vue?vue&type=script&lang=js"
export * from "./AtomButtonTheModalCloseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports